import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getDifyAssistant } from "services/difyService";
import { MdSupportAgent } from "react-icons/md";
import { TiFlowMerge } from "react-icons/ti";
import { MdOutlineChatBubbleOutline } from "react-icons/md";

const AssistantTile = ({ app }) => {
  const url = `/admin/assistant/${app.id}`;

  let navigate = useNavigate();

  const goTo = () => {
    navigate(url);
  };

  const getBackground = () => {
    switch (app.mode) {
      case "chat":
        return (
          <img
            style={{ width: "fitContent", maxWidth: "120%" }}
            src="/BA_assets-03.png"
          />
        );
      case "agent-chat":
        return (
          <img
            style={{ width: "fit-content", maxWidth: "140%" }}
            src="/BA_assets-04.png"
          />
        );
      case "workflow":
        return (
          <img
            style={{ width: "fit-content", maxWidth: "140%" }}
            src="/BA_assets-06.png"
          />
        );
      case "advanced-chat":
        return (
          <img
            style={{ width: "fit-content", maxWidth: "140%" }}
            src="/BA_assets-05.png"
          />
        );
    }
  };
  return (
    <div
      onClick={goTo}
      className="rounded-3xl flex flex-col overflow-hidden cursor-pointer bg-white"
    >
      <div
        className={`flex justify-center items-center h-[150px] overflow-hidden`}
      >
        {getBackground()}
      </div>
      <div className="p-4 flex flex-col text-[#333] mt-auto mb-auto">
        <h2 className="!font-bold !text-4xl">
          {app?.name} {app.icon?.length == 2 ? app?.icon : ""}
        </h2>
        <div className="">{app.mode}</div>
      </div>
    </div>
  );
};
export default AssistantTile;
